import React from 'react';
import { Calendar, Mountain, Activity, MapPin } from 'lucide-react';

const YearToDateWidget = ({ stats = null }) => {
  const currentYear = new Date().getFullYear();
  
  let totalDistance = 0;
  let totalElevation = 0;
  let totalActivitiesCount = 0;
  let totalTime = 0;

  if (stats && stats.annual && Array.isArray(stats.annual)) {
    const ytdData = stats.annual.find(yearData => yearData._sort === currentYear);
    if (ytdData) {
      totalDistance = ytdData.distanceKm || 0;
      totalElevation = ytdData.elevationGain || 0;
      totalActivitiesCount = ytdData.count || 0;
      totalTime = (ytdData.durationMin || 0) / 60;
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', animation: 'fadeIn 0.5s ease-out' }}>
      {/* HEADER DE SECCIÓN */}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
        <h3 style={{ margin: 0, fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Calendar size={22} style={{ color: 'var(--health-cyan)' }} /> Tu Año en Cifras
        </h3>
        <span className="text-muted text-sm">(Desde 1 Ene {currentYear})</span>
      </div>

      <div className="metric-cards-grid">
        {/* Tarjeta 1: Kilómetros Totales */}
        <div style={{
          background: `radial-gradient(ellipse at top left, rgba(0,229,255,0.12) 0%, rgba(0,229,255,0.02) 60%, transparent 100%), rgba(15,23,42,0.75)`,
          border: `1px solid rgba(0,229,255,0.2)`,
          borderRadius: '14px', padding: '1rem 1.1rem',
          display: 'flex', flexDirection: 'column', gap: '6px',
          boxShadow: `0 4px 20px rgba(0,229,255,0.05), inset 0 1px 0 rgba(0,229,255,0.12)`,
          position: 'relative'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Distancia Total</span>
            <MapPin size={14} style={{ color: '#00e5ff', opacity: 0.8 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', margin: '4px 0 2px' }}>
            <span style={{ fontSize: '2.2rem', fontWeight: 800, color: 'white', lineHeight: 1, fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}>{Math.round(totalDistance).toLocaleString('es-ES')}</span>
            <span style={{ fontSize: '1rem', color: '#00e5ff', fontWeight: 600 }}>km</span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
            Distancia cubierta este año
          </div>
        </div>

        {/* Tarjeta 2: Desnivel Acumulado */}
        <div style={{
          background: `radial-gradient(ellipse at top left, rgba(16,185,129,0.12) 0%, rgba(16,185,129,0.02) 60%, transparent 100%), rgba(15,23,42,0.75)`,
          border: `1px solid rgba(16,185,129,0.2)`,
          borderRadius: '14px', padding: '1rem 1.1rem',
          display: 'flex', flexDirection: 'column', gap: '6px',
          boxShadow: `0 4px 20px rgba(16,185,129,0.05), inset 0 1px 0 rgba(16,185,129,0.12)`,
          position: 'relative'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Desnivel Total</span>
            <Mountain size={14} style={{ color: '#10b981', opacity: 0.8 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', margin: '4px 0 2px' }}>
            <span style={{ fontSize: '2.2rem', fontWeight: 800, color: 'white', lineHeight: 1, fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}>{totalElevation.toLocaleString('es-ES')}</span>
            <span style={{ fontSize: '1rem', color: '#10b981', fontWeight: 600 }}>m</span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
            Ascenso acumulado
          </div>
        </div>

        {/* Tarjeta 3: Tiempo Total */}
        <div style={{
          background: `radial-gradient(ellipse at top left, rgba(56,189,248,0.12) 0%, rgba(56,189,248,0.02) 60%, transparent 100%), rgba(15,23,42,0.75)`,
          border: `1px solid rgba(56,189,248,0.2)`,
          borderRadius: '14px', padding: '1rem 1.1rem',
          display: 'flex', flexDirection: 'column', gap: '6px',
          boxShadow: `0 4px 20px rgba(56,189,248,0.05), inset 0 1px 0 rgba(56,189,248,0.12)`,
          position: 'relative'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Tiempo Total</span>
            <Calendar size={14} style={{ color: '#38bdf8', opacity: 0.8 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', margin: '4px 0 2px' }}>
            <span style={{ fontSize: '2.2rem', fontWeight: 800, color: 'white', lineHeight: 1, fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}>{Math.round(totalTime).toLocaleString('es-ES')}</span>
            <span style={{ fontSize: '1rem', color: '#38bdf8', fontWeight: 600 }}>hrs</span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
            Horas de entrenamiento
          </div>
        </div>

        {/* Tarjeta 4: Número de Actividades */}
        <div style={{
          background: `radial-gradient(ellipse at top left, rgba(255,87,34,0.12) 0%, rgba(255,87,34,0.02) 60%, transparent 100%), rgba(15,23,42,0.75)`,
          border: `1px solid rgba(255,87,34,0.2)`,
          borderRadius: '14px', padding: '1rem 1.1rem',
          display: 'flex', flexDirection: 'column', gap: '6px',
          boxShadow: `0 4px 20px rgba(255,87,34,0.05), inset 0 1px 0 rgba(255,87,34,0.12)`,
          position: 'relative'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Actividades Totales</span>
            <Activity size={14} style={{ color: '#ff5722', opacity: 0.8 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', margin: '4px 0 2px' }}>
            <span style={{ fontSize: '2.2rem', fontWeight: 800, color: 'white', lineHeight: 1, fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}>{totalActivitiesCount}</span>
            <span style={{ fontSize: '1rem', color: '#ff5722', fontWeight: 600 }}>sesiones</span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
            Entrenamientos completados
          </div>
        </div>
      </div>
    </div>
  );
};

export default YearToDateWidget;
